import { HandledError, RequestError, isValidationError } from '@synergy/api';

import { BankAccountErrorCode } from '../models/bank-account-error-code';

export const OverviewBankAccountErrorHandler = (error?: RequestError) => {
    const errors: HandledError<BankAccountErrorCode>[] = [];

    if (isValidationError(error)) {
        for (const violation of error.violations ?? []) {
            switch (violation.propertyPath) {
                case 'iban':
                    errors.push({
                        property: violation.propertyPath,
                        error: BankAccountErrorCode.BankAccountIbanInvalid,
                    });
                    break;
                case 'bic':
                    errors.push({
                        property: violation.propertyPath,
                        error: BankAccountErrorCode.BankAccountBicInvalid,
                    });
                    break;
            }
        }
    }
    return errors;
};
